<template>
  <div id="banner" class="text-center w-100 text-black p-2">
    <slot class="p-0"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DisclaimerBanner",
  props: {
    content: String,
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
#banner {
  border-radius: 11px;
  background: rgba(255, 191, 191, 0.45);
}

b {
  color: #e11d48 !important;
}
</style>
